import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getPerformance } from 'firebase/performance';
import { getAnalytics, isSupported } from 'firebase/analytics';
import {
  getAuth,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  onAuthStateChanged,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult
} from 'firebase/auth';

// Firebase 配置 (bmc-project-2025)
const firebaseConfig = {
  apiKey: "AIzaSyCt2SqhHX46Tz0kxIiJXJzZWn7lal3FnAw",
  authDomain: "bmc-project-2025.web.app",
  projectId: "bmc-project-2025",
  storageBucket: "bmc-project-2025.firebasestorage.app",
  messagingSenderId: "729329173492",
  appId: "1:729329173492:web:077bb8e81d3a10c6dfefa1",
  measurementId: "G-ER8P9E9Q7Z"
};

// 初始化 Firebase
const app = initializeApp(firebaseConfig);

// 初始化 Firestore
export const db = getFirestore(app);

// 初始化 Firebase Auth
export const auth = getAuth(app);

// Google Provider
export const googleProvider = new GoogleAuthProvider();

// Microsoft Provider (Entra ID)
export const microsoftProvider = new OAuthProvider('microsoft.com');
microsoftProvider.setCustomParameters({
  tenant: '250f06fd-4f95-4cc3-80ff-2bbc3d6d2459',
});

// 初始化 Performance Monitoring (only in production)
export let performance = null;
if (import.meta.env.PROD) {
  performance = getPerformance(app);
}

// 初始化 Analytics (only in production and if supported)
export let analytics = null;
if (import.meta.env.PROD) {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

// Cloud Functions URL
export const FUNCTIONS_URL = 'https://us-central1-bmc-project-2025.cloudfunctions.net/api';

// Auth helper functions
export const signInWithEmail = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

// Safari ITP 會擋 signInWithRedirect，改用 signInWithPopup
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const signInWithGoogle = () => {
  if (isSafari) {
    return signInWithPopup(auth, googleProvider);
  }
  return signInWithRedirect(auth, googleProvider);
};

export const signInWithMicrosoft = () => {
  return signInWithRedirect(auth, microsoftProvider);
};

// Handle redirect result on page load
export const handleRedirectResult = () => {
  return getRedirectResult(auth);
};

export const signOut = () => {
  return firebaseSignOut(auth);
};

export const onAuthChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};

// 獲取當前使用者的 ID Token
export const getIdToken = async () => {
  const user = auth.currentUser;
  if (!user) {
    return null;
  }
  return user.getIdToken();
};